import { Controller } from "@hotwired/stimulus"

// Safety net for the partner-reporting cards' stale-while-revalidate flow.
//
// A card frame renders a cached snapshot (or a skeleton on a cold / custom-filter
// miss) and subscribes to a Turbo Stream that Dashboard::RefreshCardSnapshotJob
// broadcasts the fresh card into. If that background refresh finishes BEFORE the
// stream subscription is live, the single broadcast can be missed and a cold card
// would sit on its skeleton indefinitely. This reloads the frame ONCE after a
// short delay if a skeleton is still showing — by then the snapshot exists and
// renders immediately. One-shot (never loops), so a persistently failing card
// settles on its skeleton/error rather than reloading forever.
export default class extends Controller {
  static values = { reloadAfter: { type: Number, default: 12000 } }

  connect() {
    if (!this.showingSkeleton()) return
    this.timer = setTimeout(() => this.reloadIfStillPending(), this.reloadAfterValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  reloadIfStillPending() {
    if (this.reloaded || !this.showingSkeleton()) return

    const frame = this.element.closest("turbo-frame")
    if (!frame) return

    this.reloaded = true
    frame.reload()
  }

  // The skeleton partial is the only descendant that uses `animate-pulse`.
  showingSkeleton() {
    return this.element.querySelector(".animate-pulse") !== null
  }
}
